import api from "./instance";
import { getLabTests, getScans, getStaffTestPackages } from "./catalog.api";

const idOf = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  return String(value._id || "");
};

const ensureCenter = (map, id, info = {}) => {
  const key = String(id || "");
  if (!key) return null;
  if (!map.has(key)) {
    map.set(key, {
      _id: key,
      name: info.name || "",
      address: info.address || "",
      phone: info.phone || "",
      email: info.email || "",
      centerType: info.centerType || "",
      image: info.image || "",
      tests: [],
      packages: [],
      scans: [],
    });
  } else {
    const center = map.get(key);
    if (!center.name && info.name) center.name = info.name;
    if (!center.address && info.address) center.address = info.address;
    if (!center.phone && info.phone) center.phone = info.phone;
    if (!center.email && info.email) center.email = info.email;
    if (!center.centerType && info.centerType) center.centerType = info.centerType;
    if (!center.image && info.image) center.image = info.image;
  }
  return map.get(key);
};

const pushUnique = (list, item) => {
  const key = String(item?._id || item?.packageId || "");
  if (!key || list.some((row) => String(row._id || row.packageId) === key)) return;
  list.push(item);
};

const safeGet = (request) => request.catch(() => ({ data: {} }));

/** Centres from staff catalog routes. Shape matches the old company-diagnostics list. */
export const loadStaffDiagnosticCenters = async () => {
  const [packagesRes, testsRes, scansRes] = await Promise.all([
    safeGet(getStaffTestPackages()),
    safeGet(getLabTests()),
    safeGet(getScans()),
  ]);

  const map = new Map();
  const packages = packagesRes.data?.myPackages || [];
  packages.forEach((pkg) => {
    const centerInfo = pkg.diagnosticCenter || {};
    const center = ensureCenter(map, centerInfo.diagnosticId, centerInfo);
    if (!center) return;
    pushUnique(center.packages, {
      _id: pkg.packageId,
      packageId: pkg.packageId,
      packageName: pkg.packageName || "",
      name: pkg.packageName || "",
      price: pkg.price || 0,
      offerPrice: pkg.offerPrice || 0,
      includedTests: pkg.includedTests || [],
      description: pkg.description || "",
      totalTestsIncluded: pkg.totalTestsIncluded || 0,
      gender: pkg.gender,
    });
  });

  const tests = testsRes.data?.data || [];
  tests.forEach((item) => {
    const test = item.testId || {};
    const testId = idOf(test);
    const diagnostics = item.allDiagnostics || [];
    diagnostics.forEach((diagnostic) => {
      const center = ensureCenter(map, diagnostic._id || diagnostic, {
        name: diagnostic.name,
      });
      if (!center || !testId) return;
      pushUnique(center.tests, {
        _id: testId,
        name: test.name || item.title || "",
        title: test.name || item.title || "",
        price: test.price ?? item.price ?? 0,
        offerPrice: test.offerPrice ?? item.offerPrice ?? 0,
      });
    });
  });

  const scans = scansRes.data?.data || [];
  scans.forEach((item) => {
    const scan = item.scanId || {};
    const diagnostic = item.diagnosticId || {};
    const center = ensureCenter(map, idOf(diagnostic) || diagnostic, {
      name: diagnostic.name,
      address: diagnostic.address,
      image: diagnostic.image,
    });
    const scanId = idOf(scan);
    if (!center || !scanId) return;
    pushUnique(center.scans, {
      _id: scanId,
      name: scan.title || scan.name || item.title || "",
      title: scan.title || scan.name || item.title || "",
      price: item.price ?? scan.price ?? 0,
    });
  });

  return { data: { data: [...map.values()] } };
};

export const getDiagnosticSlots = (diagnosticId, date, type) =>
  api.post("/staff/diagnosticslots", {
    diagnosticId: idOf(diagnosticId),
  }, {
    params: { date, type },
  });
